import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { inject } from 'mobx-react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  List,
  ListItem,
  ListItemText,
  Checkbox,
  withStyles,
  CircularProgress,
} from '@material-ui/core';
import { Button } from '../../../../components/ui/Buttons';
import { findAllProfissionalSaudeSelect } from '../../../../services/ProfissionalSaudeService';

const styles = {
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    minWidth: '360px',
  },
  list: {
    maxHeight: '300px',
    overflow: 'auto',
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    padding: '16px',
  },
};

const CreateGrupoModal = observer(({ classes, open, onClose, chatStore }) => {
  const [nome, setNome] = useState('');
  const [profissionais, setProfissionais] = useState([]);
  const [selected, setSelected] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open) {
      loadProfissionais();
      setNome('');
      setSelected([]);
    }
  }, [open]);

  const loadProfissionais = async () => {
    setLoading(true);
    try {
      const result = await findAllProfissionalSaudeSelect({
        searchDTO: { pageSize: 100, pageNumber: 0, sortDir: 'ASC', sortField: 'nome' }
      });
      const filtered = (result?.content || []).filter(p => p.id !== chatStore.loggedUser?.id);
      setProfissionais(filtered);
    } catch (e) {
      console.error(e);
    }
    setLoading(false);
  };

  const handleToggle = (profissional) => {
    const idx = selected.findIndex(s => s.id === profissional.id);
    if (idx > -1) {
      setSelected(selected.filter(s => s.id !== profissional.id));
    } else {
      setSelected([...selected, profissional]);
    }
  };

  const handleCreate = async () => {
    if (!nome.trim() || selected.length === 0) return;
    await chatStore.createNewGrupo({ nome: nome.trim(), profissionais: selected });
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Criar Grupo</DialogTitle>
      <DialogContent className={classes.content}>
        <TextField
          label="Nome do grupo"
          value={nome}
          onChange={(e) => setNome(e.target.value)}
          fullWidth
          autoFocus
        />
        <span style={{ fontWeight: 600, fontSize: 14 }}>Selecione os membros:</span>
        {loading ? (
          <div className={classes.loadingContainer}>
            <CircularProgress size={24} />
          </div>
        ) : (
          <List className={classes.list} dense>
            {profissionais.map((p) => (
              <ListItem key={p.id} button onClick={() => handleToggle(p)} dense>
                <Checkbox
                  checked={selected.some(s => s.id === p.id)}
                  color="primary"
                  size="small"
                />
                <ListItemText primary={p.nome} />
              </ListItem>
            ))}
          </List>
        )}
      </DialogContent>
      <DialogActions>
        <Button kind="transparent" onClick={onClose}>Cancelar</Button>
        <Button
          kind="primary"
          onClick={handleCreate}
          disabled={!nome.trim() || selected.length === 0}
        >
          Criar
        </Button>
      </DialogActions>
    </Dialog>
  );
});

const CreateGrupoModalStyles = withStyles(styles)(CreateGrupoModal);
export default inject('chatStore')(CreateGrupoModalStyles);
